import * as React from "react";
import { Navigate, Route, Routes, useParams } from "react-router";
import { LoginPage } from "@/auth/login-page";
import { CALLBACK_PATH } from "@/auth/portal";
import { PortalCallbackPage } from "@/auth/portal-callback";
import { RequireAuth } from "@/auth/require-auth";
import { useSession } from "@/auth/session";
import { AppShell } from "@/shell/app-shell";
import { PlaceholderPage } from "@/domains/placeholder";
import { registry } from "@/domains/registry";

function Home() {
  const accountId = useSession((s) => s.session?.accountId);
  return <Navigate to={`/a/${accountId}/pbx/users`} replace />;
}

function Loading() {
  return <div className="flex h-full items-center justify-center text-xs text-muted-foreground">Loading…</div>;
}

/** Resolve `/:domain/:section` through the per-domain registries. */
function SectionRoute() {
  const params = useParams<{ domain?: string; section?: string }>();
  const domain = params.domain ?? "pbx";
  const section = params.section ?? "";
  const Screen = registry[domain]?.[section];
  if (!Screen) return <PlaceholderPage />;
  return (
    <React.Suspense fallback={<Loading />}>
      <Screen />
    </React.Suspense>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path={CALLBACK_PATH} element={<PortalCallbackPage />} />
      <Route element={<RequireAuth />}>
        <Route index element={<Home />} />
        <Route element={<AppShell />}>
          <Route path="/a/:accountId/:domain/:section?/:id?" element={<SectionRoute />} />
          <Route path="/:domain/:section?" element={<SectionRoute />} />
        </Route>
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}
